import { motion } from "framer-motion";
import { Smartphone, Globe, Moon, Stethoscope } from "lucide-react";
const features = [{
  icon: Smartphone,
  title: "Mobile-First",
  description: "Interface otimizada para uso no celular durante o plantão"
}, {
  icon: Globe,
  title: "Acesso Online",
  description: "Disponível em qualquer dispositivo, a qualquer momento"
}, {
  icon: Moon,
  title: "Dark Mode Nativo",
  description: "Design escuro que não cansa a vista em plantões noturnos"
}, {
  icon: Stethoscope,
  title: "Interface Clínica",
  description: "Navegação intuitiva focada em decisões rápidas e seguras"
}];
export function SolutionSection() {
  return <section className="py-16 sm:py-24 px-4 bg-card/30">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">

          {/* LEFT COLUMN - Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left">
            <span className="text-accent text-xs font-semibold uppercase tracking-widest mb-3 block">
              A solução
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mb-4">
              Tudo que você precisa,{" "}
              <span className="text-accent">em segundos.</span>
            </h2>

            <p className="text-base sm:text-lg text-muted-foreground mb-6">
              Uma plataforma construída com o que você realmente usa no plantão — sem enrolação, sem teoria desnecessária.
            </p>

            <blockquote className="border-l-4 border-accent pl-4 italic text-muted-foreground mb-8 text-left text-sm sm:text-base">
              "A ferramenta que todo enfermeiro oncológico precisava ter no bolso — literalmente."
            </blockquote>

            {/* Feature Pills Stack */}
            <div className="flex flex-col gap-3">
              {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.08
              }} className="flex items-center gap-3 bg-card border border-border rounded-xl p-3 sm:p-4 hover:border-accent/40 transition-colors text-left">
                    <div className="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-accent/10 flex items-center justify-center">
                      <IconComponent className="w-4 h-4 sm:w-5 sm:h-5 text-accent" strokeWidth={2} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-foreground text-sm">
                        {feature.title}
                      </div>
                      <div className="text-xs sm:text-sm text-muted-foreground">
                        {feature.description}
                      </div>
                    </div>
                  </motion.div>;
            })}
            </div>
          </motion.div>

          {/* RIGHT COLUMN - Platform Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mt-6 lg:mt-0">
            {/* Emerald glow behind */}
            <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-3xl pointer-events-none" />
            {/* Mockup image */}
            <div className="relative rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-2xl">
              <img src="https://static-us-img.skywork.ai/prod/user/head_picture/2048214817967353856_ChatGPT Image 25 de abr. de 2026, 21_23_43.pngss.png?image_process=quality,q_90/resize,w_1280/format,webp" alt="Jornada Oncológica na Prática - Interface da Plataforma" className="w-full h-[982.5562133789062px] object-cover" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}